import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function Benefits() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-20 sm:py-32 bg-[#f5f0e8] relative" data-id="element-1">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-3">
          <p className="text-[#b4a7d6] font-bold uppercase tracking-[0.2em] mb-6 text-sm" data-id="element-4">
            Por eso creé:
          </p>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#2F4538] mb-8" data-id="element-5">
            RITUALES DE PIES ANCESTRALES
          </h2>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto mb-10 rounded-full" data-id="element-6"></div>

          <p className="text-xl sm:text-2xl text-[#1a1a1a]/80 font-medium max-w-3xl mx-auto leading-relaxed mb-8" data-id="element-7">
            El único sistema completo de transformación energética diseñado para
            mujeres argentinas que necesitan recuperar su paz mental sin salir
            de casa.
          </p>

          <div className="bg-white p-8 rounded-3xl shadow-sm border border-[#D4AF37]/20 max-w-2xl mx-auto" data-id="element-8">
            <p className="text-lg text-[#1a1a1a]/70 mb-4" data-id="element-9">
              No es un PDF más con "recetas bonitas".
            </p>
            <p className="text-xl font-bold text-[#2F4538]" data-id="element-10">
              Es un SISTEMA COMPLETO que te toma de la mano desde el primer día
              y te acompaña hasta que te convertís en una experta en limpiar tu
              energía, dormir profundo, y atraer lo que merecés.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}